module.exports = __webpack_public_path__ + "static/media/icons_Bilan Myopathie.60e077d1.svg";